import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

export const DropdownCtn = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 16px;
    padding-right: 10px;

    ${Media.Below.tablet`
      font-size: 14px;
    `}
  }

  > div {
    width: 140px;
  }

  ${Media.Below.desktop`
    justify-content: flex-end;
  `}

  ${Media.Below.tablet`
    justify-content: flex-start;
  `}
`;

export const HeadingCtn = styled.div`
  display: flex;
  justify-content: space-between;

  ${Media.Below.desktop`
    flex-direction: column;
  `}
`;

export const HeadingDropdownCtn = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60%;

  ${Media.Below.desktop`
    width: 100%;
  `}

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}

  > span {
    font-size: 30px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 24px;
    `}

    ${Media.Below.tablet`
      font-size: 22px;
    `}

    ${Media.Below.mobileLarge`
      font-size: 20px;
    `}
  }
`;

interface JobTypeBtnProps {
  active?: boolean;
}

export const JobTypeBtn = styled.div<JobTypeBtnProps>`
  align-self: flex-end;
  display: flex;
  justify-content: center;
  width: 12vw;
  max-width: 215px;
  min-width: 110px;
  font-size: 14px;
  font-weight: bold;
  border-bottom: ${THEME.colors.tertiaryFontColor} 2px solid;
  padding: 10px 0;
  cursor: pointer;
  flex: 1 1 auto;

  ${(props): SimpleInterpolation =>
    props.active &&
    css`
      border-bottom: ${THEME.colors.primaryFontColor} 2px solid;
    `}

  ${Media.Below.desktop`
    max-width: 150px;
    font-size: 13px;
  `}

  ${Media.Below.tablet`
    font-size: 13px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 12px;
    max-width: 500px;
    width: 50%;
  `}
`;

export const JobTypeCtn = styled.div`
  display: flex;
  justify-content: flex-end;

  ${Media.Below.desktop`
    justify-content: center;
  `}
`;

export const SummaryList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 50px 0 100px;

  ${Media.Below.tablet`
    margin: 30px 0 70px;
  `}

  ${Media.Below.mobileLarge`
    margin: 30px 0 70px;
  `}
`;

export const Empty = styled.div`
  flex: 0 0 14%;
  max-width: 200px;
  min-width: 190px;
  height: 0px;

  ${Media.Below.desktop`
    flex: 0 0 20%;
    max-width: 150px;
    min-width: 140px;
  `}

  ${Media.Below.mobileLarge`
    flex: 0 0 45%;
    max-width: 180px;
  `}
`;
